(function () {
  "use strict";

  var STEP = 1;
  var BIG_STEP = 10;

  function initRoot(root) {
    if (!root || root.dataset.npCsInit === "true") return;
    root.dataset.npCsInit = "true";

    var before = root.querySelector("[data-np-cs-before]");
    var after = root.querySelector("[data-np-cs-after]");
    var handle = root.querySelector("[data-np-cs-handle]");
    if (!before || !after || !handle) return;

    var pos = parseFloat(root.dataset.npCsStart);
    if (isNaN(pos)) pos = 50;
    var dragging = false;
    var pointerId = null;
    var raf = null;
    var pending = pos;

    function apply(p) {
      before.style.clipPath = "inset(0 " + (100 - p) + "% 0 0)";
      after.style.clipPath = "inset(0 0 0 " + p + "%)";
      handle.style.left = p + "%";
      handle.setAttribute("aria-valuenow", Math.round(p));
    }

    function setPos(p) {
      pos = Math.max(0, Math.min(100, p));
      pending = pos;
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        apply(pending);
      });
    }

    function posFromEvent(e) {
      var rect = root.getBoundingClientRect();
      if (!rect.width) return pos;
      return ((e.clientX - rect.left) / rect.width) * 100;
    }

    root.addEventListener("pointerdown", function (e) {
      if (e.pointerType === "mouse" && e.button !== 0) return;
      dragging = true;
      pointerId = e.pointerId;
      try {
        root.setPointerCapture(pointerId);
      } catch (_) {}
      setPos(posFromEvent(e));
      e.preventDefault();
    });

    root.addEventListener("pointermove", function (e) {
      if (!dragging) return;
      setPos(posFromEvent(e));
    });

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      if (pointerId !== null) {
        try {
          root.releasePointerCapture(pointerId);
        } catch (_) {}
        pointerId = null;
      }
    }
    root.addEventListener("pointerup", endDrag);
    root.addEventListener("pointercancel", endDrag);

    /* Keep the native drag ghost off the images. */
    root.addEventListener("dragstart", function (e) {
      e.preventDefault();
    });

    handle.addEventListener("keydown", function (e) {
      var next = null;
      switch (e.key) {
        case "ArrowLeft":
          next = pos - STEP;
          break;
        case "ArrowRight":
          next = pos + STEP;
          break;
        case "PageDown":
          next = pos - BIG_STEP;
          break;
        case "PageUp":
          next = pos + BIG_STEP;
          break;
        case "Home":
          next = 0;
          break;
        case "End":
          next = 100;
          break;
        default:
          return;
      }
      e.preventDefault();
      setPos(next);
    });

    apply(pos);
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll("[data-np-cs]");
    Array.prototype.forEach.call(roots, initRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (e) {
    initAll(e.target);
  });
})();
